import { List } from '@mui/material'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import CalibrationTestListItem from './CalibrationTestListItem'

type Props = Readonly<{ id: string; errorCodes: number[] }>

export default function ErrorList({ id, errorCodes }: Props): JSX.Element {
  const { t } = useTranslation('app')

  return (
    <List id={id}>
      <CalibrationTestListItem
        key="deviceErrors"
        label={
          errorCodes.length > 0
            ? t('device.calibration.testStep.hasErrors')
            : t('device.calibration.testStep.noErrors')
        }
        status={errorCodes.length > 0 ? 1 : 0}
      />
      {errorCodes.map((code) => {
        const errorKey = `di:rpc.error.${code}`
        const label = `[${code}]: ${t(errorKey, { defaultValue: t('di:rpc.error.undefined') })}`
        return <CalibrationTestListItem key={code} label={label} status={1} />
      })}
    </List>
  )
}
